import { Components, Theme } from "@mui/material";

export const MuiTableCell: Components<Theme>["MuiTableCell"] = {
  styleOverrides: {
    head: ({ theme }) => {
      return {
        ...theme.typography.tableHeader,
        textWrap: "wrap",
        border: "none",
        borderBottom: "1px solid #E3E8EF",
        // background: theme.palette.primary.contrastText
      };
    },
    body: ({ theme }) => {
      return {
        ...theme.typography.tableCellRegular,
        textTransform: "none",
        textOverflow: "ellipsis",
        overflowX: "hidden",
        borderBottom: "1px solid #E3E8EF",
      };
    },
  },
  variants: [
    {
      props: {
        variant: "bold",
      },
      style: ({ theme }) => ({
        ...theme.typography.tableCellBold,
      }),
    },
  ],
};
